import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { FakeNotificationsHOC } from '../notifications/hocs/FakeNotificationsHOC/FakeNotificationsHOC';
import store from '../../../store/configureStore';
import { NAVIGATION_PANEL_DROPDOWN_CLASS } from '../main/navigationPanel/constants';

export class FakeNotifications {
    el: HTMLElement;

    constructor () {
        if (this.el) this.remove();
        this.el = document.createElement('div');
        this.el.className = 'fake-notifications-placeholder';
        const container = document.querySelector(`.${NAVIGATION_PANEL_DROPDOWN_CLASS} .dropdown__body`);
        if (!container) return;
        container.prepend(this.el);
        this.render();
    }

    render () {
        ReactDOM.render(
            <Provider store={store}>
                <FakeNotificationsHOC />
            </Provider>
            , this.el);
    }

    remove () {
        if (!this.el) return;

        ReactDOM.unmountComponentAtNode(this.el);
        this.el.remove();
        this.el = null;
    }
}
